import { useState, useEffect } from 'react'
import StorageUtil, {
  LOCAL,
  BANNER_DISMISSED_KEY,
} from '../../../../utils/storage-util'
import { getIntegrationDetails } from '../../../../utils/upgradehub-util'
import { useApplicationContext } from '../../../../context/ApplicationContext'
import { ELMO_EXPERIMENTS } from '../../../../constants'
import logUtil from '../../../../utils/log-util'

const upgradeHubStateStorage = new StorageUtil(LOCAL)

const useOutdatedAppsBanner = () => {
  const { upgradehub_v2, user } = useApplicationContext()
  const isUpgradeHubActive =
    upgradehub_v2 === ELMO_EXPERIMENTS.UpgradeHub.Treatment
  const [outdatedApps, setOutdatedApps] = useState([])
  const [hasOutdatedApps, setHasOutdatedApps] = useState(false)
  const [isOutdatedAppsLoading, setIsOutdatedAppsLoading] = useState(false)
  const [outdatedAppsError, setOutdatedAppsError] = useState(false)
  const [bannerDismissed, setBannerDismissed] = useState(
    upgradeHubStateStorage.getItem(BANNER_DISMISSED_KEY) === 'true',
  )

  const getOutdatedApps = async () => {
    setIsOutdatedAppsLoading(true)
    try {
      if (isUpgradeHubActive && user && !bannerDismissed) {
        const integrationData = await getIntegrationDetails(
          user?.encryptedAccountNumber,
        )
        if (integrationData?.integration_details?.length > 0) {
          setOutdatedApps(integrationData?.integration_details)
          setHasOutdatedApps(true)
        }
      }
    } catch (err) {
      setOutdatedAppsError(true)
      logUtil.error(err)
    } finally {
      setIsOutdatedAppsLoading(false)
    }
  }

  useEffect(() => {
    getOutdatedApps()
  }, [])

  const closeOutdatedAppsBanner = () => {
    setHasOutdatedApps(false)
    upgradeHubStateStorage.setItem(BANNER_DISMISSED_KEY, 'true')
    setBannerDismissed(
      upgradeHubStateStorage.getItem(BANNER_DISMISSED_KEY) === 'true',
    )
  }

  return {
    hasOutdatedApps,
    outdatedApps,
    isOutdatedAppsLoading,
    outdatedAppsError,
    closeOutdatedAppsBanner,
  }
}

export default useOutdatedAppsBanner
